import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import type KybWorkflow from '@banking/savings-onboarding-app/services/kyb-workflow';
import {
  backButtonClickAction,
  businessTypeScreenUpdateAction,
} from '@banking/ui/workflows/onboarding-kyb/action';
import { action } from '@ember/object';
import { BusinessTypeScreenData } from '@banking/ui/workflows/onboarding-kyb/state';

export default class BusinessTypeController extends Controller {
  @service kybWorkflow!: KybWorkflow;

  @action submit(data: BusinessTypeScreenData) {
    this.kybWorkflow.emit(businessTypeScreenUpdateAction(data));
  }

  @action goBack() {
    this.kybWorkflow.emit(backButtonClickAction());
  }
}
